module.exports = __webpack_public_path__ + "static/media/LoginImage.c785bae1.png";